import * as React from "react";
import { Card } from "@/ui/components/Card";
import { useAuth } from "@/lib/auth/hooks";
import { getAuthCookie } from "@/lib/auth/session-cookie";
import { fetchCertificationResources } from "@/lib/api/certifications";
import type { CertificationResource } from "@/lib/api/certifications";
import { useI18n } from "@/app/lib/i18n";
import * as s from "./CertificationContent.css";

export function ResourcesPage() {
  const { t, tx } = useI18n();
  const { accessToken } = useAuth();
  const token = accessToken ?? getAuthCookie("access_token");

  const [resources, setResources] = React.useState<CertificationResource[]>([]);
  const [loading, setLoading] = React.useState(true);
  const [error, setError] = React.useState<string | null>(null);

  React.useEffect(() => {
    if (!token) return;
    setLoading(true);
    fetchCertificationResources(token)
      .then(setResources)
      .catch((err) => setError(err?.message || t("certification.resources.loadError")))
      .finally(() => setLoading(false));
  }, [token, t]);

  return (
    <div className={s.page}>
      <h1 className={s.pageTitle}>{tx("certification.resources.title")}</h1>

      {loading && <p className={s.muted}>{tx("shared.common.loading")}</p>}
      {error && <p className={s.error}>{error}</p>}
      {!loading && !error && resources.length === 0 && (
        <p className={s.muted}>{tx("certification.resources.empty")}</p>
      )}

      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fill, minmax(240px, 1fr))",
          gap: 16,
        }}
      >
        {resources.map((resource) => (
          <a
            key={resource.id}
            href={resource.url}
            target="_blank"
            rel="noreferrer"
            style={{ textDecoration: "none", color: "inherit" }}
          >
            <Card>
              <div className={s.resourceThumb}>
                {resource.type === "video"
                  ? t("certification.resources.typeVideo")
                  : t("certification.resources.typePdf")}
              </div>
              <p style={{ fontWeight: 600 }}>{resource.title}</p>
            </Card>
          </a>
        ))}
      </div>
    </div>
  );
}
